import { Container } from 'inversify';
import { IApiService, IApiServiceContract } from './';
import { ApiService } from './ApiService';

export class ApiLayer {

    public static register(container: Container): void {

        container.bind<IApiService>(IApiServiceContract).to(ApiService).inSingletonScope();

    }

}
